import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { BrandMark, useThemeRoot } from './Shell'
import '@/styles/gg.css'
import '@/styles/auth2.css'

/** Sign in, sign up and their confirmations, in the app's own look. */
export function AuthLayout({ eyebrow, title, lede, children, foot }: {
  eyebrow: string
  title: string
  lede?: ReactNode
  children: ReactNode
  foot?: ReactNode
}) {
  const theme = useThemeRoot()
  return (
    <div className="gg auth2" data-theme={theme}>
      <header className="auth2__top">
        <Link to="/" aria-label="GoGrov home"><BrandMark /></Link>
      </header>
      <main className="auth2__main">
        <div className="auth2__card">
          <img className="auth2__sprout" src="/brand/sprout-hook-cream.svg" alt="" width={64} height={64} />
          <span className="eyebrow eyebrow--accent">{eyebrow}</span>
          <h1 className="auth2__title">{title}</h1>
          {lede && <p className="auth2__lede">{lede}</p>}
          {children}
        </div>
        {foot && <div className="auth2__foot">{foot}</div>}
      </main>
    </div>
  )
}
